import { render, staticRenderFns } from "./AddPatient.vue?vue&type=template&id=acf73f1e"
import script from "./AddPatient.vue?vue&type=script&lang=js"
export * from "./AddPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports